<template>
  <div class="zyz-wrapper">
    <div class="zyz-head" v-if="isShowDefaultTitle">优秀志愿者</div>
    <div style="padding:0px 10px">
      <x-scroll :contentArr="num" :height="311" :lineNum="3" :width="212" :time='5000'>
        <div class="zyz-item" slot="scroll" slot-scope="props">
          <div class="picture"></div>
          <!-- <img style="height: 150px;width: 150px" src="./1.png"> -->
        </div>
      </x-scroll>
   </div>
  </div>
</template>
<script>
  import xScroll from '../../../components/xScroll'
  export default {
    props: {
      isShowDefaultTitle: {
        default: true,
        type: Boolean,
      }
    },
    components: {
      xScroll
    },
    data () {
      return {
        num:[1,2,3]
      }
    }
  }
</script>
<style scoped>
  .zyz-wrapper{
    width:575px;
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 30px;
    color:#444;
  }
  .zyz-head{
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .zyz-item{
    width: 200px;
    height: 311px;
    display: flex;
    flex-flow: column;
    margin-right:12px
  }
  .zyz-name{
    text-align: center;
    background: #fff2df;
    flex:1;
    line-height: 30px
  }
  .picture{
    width:100%;
    height: 311px;
    background: url('./jiashequ.png');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: auto 100%;
   /* width:200px;
   height:311px;
   background-size: 100%;
   background-image: url('./jiashequ.png');
   background-repeat: no-repeat; */
    /* width:200px;
    height:311px;
    background-image: url('./jiashequ.png');
    background-repeat: no-repeat;
    background-size:100%;
    background-position: center; */
  }
</style>

